export default __webpack_public_path__ + "static/media/mythicalbeings-transparent-160px.e4e054d8.png";